import * as React from 'react';

export class BlurryLoader extends React.Component {
    render() {
        return <div className='BlurryLoader'>{this.props.children}</div>;
    }
}

export default BlurryLoader;
